<template>
  <IEScreen v-if="isIE" />
  <!-- <AgeGate v-else /> -->
  <div style="height: 100vh;" v-else>
    <router-view />
  </div>
</template>

<script>
import IEScreen from "./components/IEScreen";
// import AgeGate from "./components/AgeGate";

export default {
  name: "App",
  components: {
    IEScreen,
    // AgeGate,
  },
  mounted() {
    //console.log('p', this.$router.currentRoute)
    
  },
  created() {
    const query = location.search;
    localStorage.setItem('query', query);
    console.log(query);
  },
  computed: {
    isIE() {
      const ua = window.navigator.userAgent;
      return /MSIE|Trident/.test(ua);
    },
  },
};
</script>

<style lang="stylus">
@import './styles/main.styl';
</style>
